/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';

import styles from '../../styles';
import Localized from '../../../shared/components/Localized';

const RadioInput = styled.input`
  width: 1px;
  height: 1px;
  border: 0;
  clip: rect(0 0 0 0);
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
`;

const FauxRadio = styled.span`
  width: 1rem;
  height: 1rem;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  border: 1px solid #dddbda;
  border-radius: 50%;
  background: white;
  transition: border 0.1s linear, background-color 0.1s linear;

  margin-right: 0.5rem;

  /* If Radio Input is checked, then draw the radion dot
  in the next label's child FauxRadio's after area */
  ${RadioInput}:focus + label & {
    border-color: #1589ee;
    box-shadow: 0 0 3px #0070D2;
  }

  /* If Radio Input is checked, then draw the radion dot
  in the next label's child FauxRadio's after area */
  ${RadioInput}:checked + label &:after {
    width: 0.5rem;
    height: 0.5rem;
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    border-radius: 50%;
    background: #1589ee;
  }

  ${RadioInput}[disabled] + label & {
    background-color: #ecebea;
    border-color: #c9c7c5;
  }
`;

const Label = styled.span`
  display: inline;

  vertical-align: middle;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #706e6b;

  margin-right: 0.75rem;
  margin-bottom: 0.125rem;
`;

class RadioButtonComponent extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    // Use the original prop value, not the value in the dom, which has been cast to a string
    const { value, onChange } = this.props;
    if (onChange) onChange(value);
  }

  render() {
    const {
      id, name, text, value, className, checked,
      disabled, instanceOrProduct
    } = this.props;
    return (
      <div className={className}>
        <RadioInput type='radio' checked={checked} id={id}
          name={name} value={value} onChange={this.onChange} disabled={Boolean(disabled)} />
        <label htmlFor={id}>
          <FauxRadio active={true} />
          <Label><Localized
            modelKey={text}
            modelAttribute='label'
            modelName={instanceOrProduct} /></Label>
        </label>
      </div>
    );
  }
}

export default RadioButtonComponent;
